import styled from 'styled-components';
import colors from '../../styles/colors';

const Wrapper = styled.div`
  position: relative;
  flex: 1;
  min-height: 0;
  display: flex;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  background-color: ${colors.base.gamma};
  padding: 10px;
`;

const MessageListEnd = styled.div`
  height: 0;
`;

const DateSeparator = styled.div`
  background-color: ${colors.shades.gamma1};
  padding: 5px 10px;
  margin: 20px;
  border-radius: 25px;
  text-align: center;
  font-size: 0.75rem;
  font-weight: bold;
  opacity: 0.5;
`;

const ScrollToBottomButton = styled.button`
  position: absolute;
  bottom: 16px;
  right: 16px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${colors.base.alpha};
  border: 1px solid ${colors.shades.gamma3};
  box-shadow: 0 2px 8px ${colors.shades.gamma4};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${colors.shades.gamma1};
  }
`;

const MessageAnchor = styled.div`
  border-radius: 8px;
  transition: background-color 0.4s ease;
  background-color: ${({ $isHighlighted }) => ($isHighlighted ? colors.shades.gamma1 : 'transparent')};
`;

const InternalIntervention = styled.div`
  align-self: center;
  max-width: 70%;
  margin: 6px 0 16px;
  padding: 10px 14px;
  border-radius: 8px;
  background-color: ${colors.shades.secondary6};
  color: ${colors.shades.gamma10};
  font-size: 0.875rem;
`;

const InternalInterventionTitle = styled.div`
  margin-bottom: 4px;
  color: ${colors.shades.secondary3};
  font-size: 0.75rem;
  font-weight: bold;
`;

const InternalInterventionTime = styled.div`
  margin-top: 4px;
  text-align: right;
  font-size: 0.7rem;
`;

export {
  Wrapper,
  Container,
  MessageListEnd,
  DateSeparator,
  ScrollToBottomButton,
  MessageAnchor,
  InternalIntervention,
  InternalInterventionTitle,
  InternalInterventionTime,
};
